export default __webpack_public_path__ + "static/media/level.dca72713.svg";